<template>
  <userSettings></userSettings>
</template>

<script>
import userSettings from "@/components/Settings.vue";
export default {
  metaInfo() {
    return {
      title: this.$i18n.t("Settings page")
    };
  },
  name: "settings",
  components: {
    userSettings
  }
};
</script>
